import { render } from "./ServicesDetailsMobileWeb.vue?vue&type=template&id=e8a696f0"
import script from "./ServicesDetailsMobileWeb.vue?vue&type=script&lang=js"
export * from "./ServicesDetailsMobileWeb.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__